import { render, staticRenderFns } from "./completed-packing.vue?vue&type=template&id=b7e214d6"
import script from "./completed-packing.vue?vue&type=script&lang=js"
export * from "./completed-packing.vue?vue&type=script&lang=js"
import style0 from "./completed-packing.vue?vue&type=style&index=0&id=b7e214d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports